import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSend = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    {...props}
  >
    <path
      fill='currentColor'
      d='m22 2 .944.33a1 1 0 0 0-1.274-1.274zm-7 20-.914.406a1 1 0 0 0 1.858-.076zM2 9l-.33-.944a1 1 0 0 0-.076 1.858zm19.293-7.707-11 11 1.414 1.414 11-11zm-.237.377-7 20 1.888.66 7-20zm-5.142 19.924-4-9-1.828.812 4 9zm-4.508-9.508-9-4-.812 1.828 9 4zM2.33 9.944l20-7-.66-1.888-20 7z'
    />
  </svg>
);
export default SvgSend;
